import _implicitStylesheets from "./securityDetails.css";
import _implicitScopedStylesheets from "./securityDetails.scoped.css?scoped=true";
import _i18nLink from "i18n/link";
import _wdsPopoverTooltip from "wds/popoverTooltip";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-7"${3}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<span type-style="body-3" class="title${0}"${2}>${"t1"}</span>`;
const $fragment3 = parseFragment`<div type-style="body-3"${3}>${"t1"}</div>`;
const $fragment4 = parseFragment`<span type-style="body-3" class="title${0}"${2}>${"t1"}</span>`;
const $fragment5 = parseFragment`<div type-style="body-3"${3}>${"t1"}</div>`;
const stc0 = {
  "requirements": true
};
const stc1 = {
  "data-testid": "requirements"
};
const stc2 = {
  "data-testid": "description"
};
const stc3 = {
  classMap: {
    "last-reviewed": true
  },
  attrs: {
    "data-testid": "last-reviewed-version"
  },
  key: 4
};
const stc4 = {
  classMap: {
    "section-title-container": true
  },
  key: 5
};
const stc5 = {
  "tooltip-container": true
};
const stc6 = {
  classMap: {
    "last-reviewed": true
  },
  attrs: {
    "data-testid": "last-reviewed-date"
  },
  key: 11
};
const stc7 = {
  classMap: {
    "section-title-container": true
  },
  key: 12
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element} = $api;
  return [api_static_fragment($fragment1, 1, [api_static_part(1, null, api_dynamic_text($cmp.staticLabels.title))]), $cmp.requirements ? api_custom_element("i18n-link", _i18nLink, {
    classMap: stc0,
    attrs: stc1,
    props: {
      "message": $cmp.requirements,
      "target": "_blank"
    },
    key: 2
  }) : null, $cmp.description ? api_custom_element("i18n-link", _i18nLink, {
    attrs: stc2,
    props: {
      "message": $cmp.description,
      "target": "_blank"
    },
    key: 3
  }) : null, $cmp.lastReviewedVersion ? api_element("div", stc3, [api_element("div", stc4, [api_static_fragment($fragment2, 7, [api_static_part(1, null, api_dynamic_text($cmp.staticLabels.lastReviewedVersion))]), api_custom_element("wds-popover-tooltip", _wdsPopoverTooltip, {
    classMap: stc5,
    props: {
      "tooltipData": $cmp.staticLabels.lastReviewedVersionTooltip,
      "popoverOrientation": $cmp.popoverOrientation
    },
    key: 8
  })]), api_static_fragment($fragment3, 10, [api_static_part(1, null, api_dynamic_text($cmp.lastReviewedVersion))])]) : null, $cmp.lastReviewedDate ? api_element("div", stc6, [api_element("div", stc7, [api_static_fragment($fragment4, 14, [api_static_part(1, null, api_dynamic_text($cmp.staticLabels.lastReviewedDate))]), api_custom_element("wds-popover-tooltip", _wdsPopoverTooltip, {
    classMap: stc5,
    props: {
      "tooltipData": $cmp.staticLabels.lastReviewedDateTooltip,
      "popoverOrientation": $cmp.popoverOrientation
    },
    key: 15
  })]), api_static_fragment($fragment5, 17, [api_static_part(1, null, api_dynamic_text($cmp.lastReviewedDate))])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5284554n7lr";
tmpl.legacyStylesheetToken = "undefined-_securityDetails";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
